import FamilyImage from "../../../../content/articles/2015-04-23-object-hierarchy-in-ruby/camelib-family.jpg";
import React from 'react';
export default {
  FamilyImage,
  React
};